export const primaryNav = [
  { label: 'Home', path: '/' },
  { label: 'Services', path: '/services' },
  { label: 'Pricing', path: '/pricing' },
  { label: 'Work', path: '/work' },
  { label: 'About', path: '/about' },
  { label: 'Contact', path: '/contact' },
];

export const footerNav = [
  { label: 'Home', path: '/' },
  { label: 'Services', path: '/services' },
  { label: 'Pricing', path: '/pricing' },
  { label: 'Work', path: '/work' },
  { label: 'About', path: '/about' },
  { label: 'Contact', path: '/contact' },
];

export const socialLinks = [
  {
    label: 'Email',
    href: 'mailto:contact@loganbarsell.com',
  },
  {
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/in/logan-barsell/',
  },
  {
    label: 'GitHub',
    href: 'https://github.com/logan-barsell',
  },
];
